import {
  GET_MATERIAL,
  SET_PAGE,
  SET_SEARCH,
  SET_PRODUCT_ID,
  SET_ORDER_BY,
  SET_SORT_BY,
} from "../../shared/constants/ActionTypes";

const initialMaterial = {
  eh_materialContent: [],
  materialContentCount: 0,
  page: 1,
  search: "",
  courseId: "",
  materialContentId: "",
  sortby: "",
  orderby: "desc",
};

const qnaReducer = (state = initialMaterial, action) => {
  switch (action.type) {
    case GET_MATERIAL:
      return {
        ...state,
        eh_materialContent: action.payload.materialContent,
        materialContentCount: action.payload.total,
        materialContentId: action.payload.materialContentId,
      };
    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };
    case SET_PRODUCT_ID:
      return {
        ...state,
        courseId: action.payload,
      };
    case SET_SORT_BY:
      return {
        ...state,
        sortby: action.payload,
      };
    case SET_ORDER_BY:
      return {
        ...state,
        orderby: action.payload,
      };
    default:
      return state;
  }
};

export default qnaReducer;
